<template>
  <div>
    <section class="page-content">
      <form action @submit.prevent="next">
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="qtn mrpx-5"></span>Other Coverages (Quote Request)
          </label>
          <div class="row">
            <div class="col-md-6">
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="coverages"
                    value
                    class="orep-radio position-relative"
                    v-model="sipApplication.cyberPrivacyCrimeCoverage"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Cyber/Privacy/Crime Coverage</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="coverages"
                    value
                    class="orep-radio position-relative"
                    v-model="sipApplication.workersCompensation"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Workers Compensation</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="coverages"
                    value
                    class="orep-radio position-relative"
                    v-model="sipApplication.suretyLicenseBonds"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Surety / License Bonds</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="coverages"
                    value
                    class="orep-radio position-relative"
                    v-model="sipApplication.commercialAuto"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Commercial Auto</span>
                </label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="coverages"
                    value
                    class="orep-radio position-relative"
                    v-model="sipApplication.directorsAndOfficersLiability"
                  >
                  <span
                    class="radio-span solo-checkbox-span no-top"
                  >Directors and Officers Liability (D&O)</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="coverages"
                    value
                    class="orep-radio position-relative"
                    v-model="sipApplication.employeePracticeLiability"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Employee Practice Liability (EPLI)</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="coverages"
                    value
                    class="orep-radio position-relative"
                    v-model="sipApplication.droneUnmannedAircraftLiability"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Drone / Unmanned Aircraft Liability</span>
                </label>
              </div>
              <!--                  <div class="radio orep-radio-wrapper solo-checkbox">-->
              <!--                    <label class="d-flex align-items-center">-->
              <!--                      <input-->
              <!--                        type="checkbox"-->
              <!--                        name="deductible"-->
              <!--                        value-->
              <!--                        class="orep-radio position-relative"-->
              <!--                        v-model="sipApplication.cyberProtection"-->
              <!--                      >-->
              <!--                      <span-->
              <!--                        class="radio-span solo-checkbox-span no-top"-->
              <!--                      >Cyber Protection: I would like information on Cyber Coverage ($89 for $100,000 limits; $59 for $50,000 limits)</span>-->
              <!--                    </label>-->
              <!--                  </div>-->
            </div>

          </div>
        </article>

        <article class="form-heading input-section form-section review-sign">
          <div class="row mb-3">
            <label class="input-info col-md-12">
              <strong>Applicant's Warranty Statement:</strong> The undersigned represents to the best of his/her knowledge and belief the particulars and statements set forth are true and agree that those particulars and statements are material to the acceptance of the risk assumed by the Company.  The undersigned further declares that any claim, incident or event taking place prior to the effective date of the insurance applied for which may render inaccurate, untrue, or incomplete any statement made will immediately be reported in writing to the applied for which may render inaccurate, untrue, or incomplete any statement made will immediately be reported in writing to the Company and the Company may withdraw or modify and any outstanding quotations and/or authorization or agreement to bind the insurance.  The signing of the Application does not bind the undersigned to purchase the insurance, nor does the review of the Application bind the Company to issue a policy.  It is understood the Company is relying on the Application in the event the Policy is issued.  It is agreed that this Application, including any material submitted therewith, shall be the basis of the contract should a policy be issued, and may be attached dot and become part of the policy.</label>
          </div>
          <div class="row mb-3">
            <div class="col-md-12">
              <section class="notice-form mt-3">
                <label class="notice-form-date">Applicant's Signature:</label>
                <input
                  type="text"
                  class="orep-text-input notice-input w-100"                  
                  name="nameForWarrantyStatement"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                  v-model="sipApplication.nameForWarrantyStatement"
                >
                <span
                  v-show="errors.has('nameForWarrantyStatement')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('nameForWarrantyStatement') | filterText }}</span>
              </section>
            </div>                      
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <section class="notice-form mt-3">
                <label class="notice-form-date">Name (please print):</label>
                <input
                  type="text"
                  class="orep-text-input notice-input w-100"                  
                  name="signatureForWarrantyStatement"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                  v-model="sipApplication.signatureForWarrantyStatement"
                >
                <span
                  v-show="errors.has('signatureForWarrantyStatement')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('signatureForWarrantyStatement') | filterText }}</span>
              </section>
            </div>
            <div class="col-md-5 ml-auto">
              <section class="notice-form mt-3">
                <label class="notice-form-date">Date:</label>
                <input
                  type="date"
                  class="orep-text-input notice-input text-center w-100"
                  :value="formattedCurrentDate()"
                  disabled
                >
              </section>
            </div>

            <div class="col-md-5 ml-auto">
              <section class="notice-form mt-3">
                <label class="notice-form-date">Desired Effective Date:</label>
                <datepicker
                  name="effectiveDate"
                  v-model="sipApplication.effectiveDate"
                  v-validate="'required'"
                  format="MM/dd/yyyy"
                  input-class="orep-text-input w-100 notice-input"
                  @input="validateBeforeSubmit()"
                  :disabled="state.effectiveDate"
                  :clearButton="false"
                  :value="computedDates"
                ></datepicker>
                <span
                  v-show="errors.has('effectiveDate')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('effectiveDate') | filterText }}</span>
              </section>
            </div>
          </div>
<!--          <label v-if="state.sipApplication.customer.state == 'FL'"  for class="orep-label">-->
<!--            <span class="qtn mrpx-5"></span>FOR FLORIDA APPLICANTS ONLY:-->
<!--          </label>-->
<!--          <div v-if="state.sipApplication.customer.state == 'FL'" class="row mb-3">-->
<!--            <div class="col-md-6">-->
<!--              <label>-->
<!--                Insurance Agent's Name:-->
<!--              </label>-->
<!--              <div class="flex">-->
<!--                <input-->
<!--                    type="text"-->
<!--                    class="orep-text-input notice-input w-100"                  -->
<!--                    name="nameForWarrantyStatement"-->
<!--                    v-validate="'required'"-->
<!--                    @input="validateBeforeSubmit()"-->
<!--                    v-model="sipApplication.nameForWarrantyStatement"-->
<!--                  >-->
<!--                <label class="w-100 name-tag-wrapper">-->
<!--                  OREP Insurance-->
<!--                </label>-->
<!--              </div>              -->
<!--            </div>-->
<!--            <div class="col-md-6">-->
<!--              <label>-->
<!--                Agent's License Identification Number:-->
<!--              </label>-->
<!--              <input-->
<!--                    type="text"-->
<!--                    class="orep-text-input notice-input w-100"                  -->
<!--                    name="identificationNumber"-->
<!--                    v-validate="'required'"-->
<!--                    @input="validateBeforeSubmit()"-->
<!--                    v-model="sipApplication.identificationNumber"-->
<!--                  >-->
<!--            </div>            -->
<!--          </div>-->
<!--          <div v-if="state.sipApplication.customer.state == 'FL'" class="row mb-3">-->
<!--            <div class="col-md-6">-->
<!--              <label>-->
<!--                Services, LLC:-->
<!--              </label>-->
<!--              <input-->
<!--                    type="text"-->
<!--                    class="orep-text-input notice-input w-100"                  -->
<!--                    name="ServicesLLC"-->
<!--                    v-validate="'required'"-->
<!--                    @input="validateBeforeSubmit()"-->
<!--                    v-model="sipApplication.ServicesLLC"-->
<!--                  >-->
<!--            </div>-->
<!--            <div class="col-md-6">-->
<!--              <label>-->
<!--                Insurance Agent's Signature-->
<!--              </label>-->
<!--              <input-->
<!--                    type="text"-->
<!--                    class="orep-text-input notice-input w-100"                  -->
<!--                    name="ServicesLLC"-->
<!--                    v-validate="'required'"-->
<!--                    @input="validateBeforeSubmit()"-->
<!--                    v-model="sipApplication.ServicesLLC"-->
<!--                  >-->
<!--            </div>-->
<!--          </div>-->

          <label for="">
            Coverage is not effective until approved by our underwriters and you receive our written conformation coverage is bound with your effective date and policy number is if you qualify, your effective date will be the date of your expiring policy subject to our receiving this request prior to the expiration date of that policy or if this is the first time you have purchased coverage, the date we approve your application.
          </label>
        </article>
        <div class="row">
          <div class="col-md-12">
            <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
              <h1 class="font-weight-bold text-center">***FRAUD WARNING STATEMENTS****</h1>
            </article>
            <article class="input-section form-section">
              <div>
                <p class="mb-3">
                  <strong>NOTICE TO FLORIDA APPLICANTS:</strong> Any person who knowingly and with intent to injure, defraud or deceive any insurer files a statement of claim or an application (or any supplemental application, questionnaire or similar document) containing any false, incomplete or misleading information is guilty of a felony of the third degree.
                </p>
                <p class="mb-3">
                  <strong>NOTICE TO KENTUCKY APPLICANTS:</strong> Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance containing any materially false information or conceals, for the purpose of misleading, information concerning any fact material thereto commits a fraudulent insurance act, which is a crime.
                </p>
                <p class="mb-3">
                  <strong>NOTICE TO OREGON APPLICANTS:</strong> Any person who knowingly and with intent to defraud any insurance company or another person, files an application for insurance or statement of claim containing any materially false information, or conceals information for the purpose of misleading, commits a fraudulent insurance act, which may be a crime and may subject such person to criminal and civil penalties.
                </p>
                <p class="mb-3">
                  <strong>NOTICE TO PENNSYLVANIA APPLICANTS:</strong> Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance or statement of claim containing any materially false information or conceals for the purpose of misleading, information concerning any fact material thereto commits a fraudulent insurance act, which is a crime and subjects such person to criminal and civil penalties.
                </p>
                <p class="mb-3">
                  <strong>NOTICE TO VIRGINIA APPLICANTS:</strong> It is a crime to knowingly provide false, incomplete or misleading information to an insurance company for the purpose of defrauding the company. Penalties include imprisonment, fines and denial of insurance benefits.
                </p>
                <p class="mb-3">
                  <strong>NOTICE TO WEST VIRGINIA APPLICANTS:</strong> Any person who knowingly presents a false or fraudulent claim for payment of a loss or benefit or knowingly presents false information in an application for insurance is guilty of a crime and may be subject to fines and confinement in prison.
                </p>
                <p class="mb-3">
                  <strong>NOTICE TO VIRGINIA APPLICANTS:</strong> It is a crime to knowingly provide false, incomplete or misleading information to an insurance company for the purpose of defrauding the company. Penalties include imprisonment, fines and denial of insurance benefits.
                </p>
                <p class="mb-3">
                  <strong>NOTICE TO ALL OTHER APPLICANTS:</strong> ANY PERSON WHO KNOWINGLY AND WITH INTENT TO DEFRAUD ANY INSURANCE COMPANY OR ANOTHER PERSON, FILES AN APPLICATION FOR INSURANCE OR STATEMENT OF CLAIM CONTAINING ANY MATERIALLY FALSE INFORMATION, OR CONCEALS INFORMATION FOR THE PURPOSE OF MISLEADING, COMMITS A FRAUDULENT INSURANCE ACT, WHICH IS A CRIME AND MAY SUBJECT SUCH PERSON TO CRIMINAL AND CIVIL PENALTIES.
                </p>
                <p>
                </p>
              </div>
            </article>
            <article class="input-section form-section">
              <label class="orep-label text-center">
                <span class="qtn mrpx-5"></span>NOTICE TO APPLICANTS. PLEASE READ CAREFULLY
              </label>
              <div>
                <p class="mb-3">
                  BY SIGNING THIS APPLICATION, THE APPLICANT REPRESENTS TO THE COMPANY THAT ALL STATEMENTS MADE IN THIS APPLICATION AND ATTACHMENTS HERETO ABOUT THE APPLICANT AND ITS OPERATIONS ARE TRUE AND COMPLETE, AND THAT NO MATERIAL FACTS HAVE BEEN MISSTATED OR MISREPRESENTED IN THIS APPLICATION, SUPPRESSED OR CONCEALED. THE UNDERSIGNED AGREES THAT IF AFTER THE DATE OF THIS APPLICATION AND PRIOR TO THE EFFECTIVE DATE OF ANY POLICY BASED ON THIS APPLICATION, ANY OCCURRENCE, EVENT OR OTHER CIRCUMSTANCE SHOULD RENDER ANY OF THE INFORMATION CONTAINED IN THIS APPLICATION INACCURATE OR INCOMPLETE, THEN THE UNDERSIGNED SHALL NOTIFY THE COMPANY OF SUCH OCCURRENCE, EVENT OR CIRCUMSTANCE AND SHALL PROVIDE THE COMPANY WITH INFORMATION THAT WOULD COMPLETE, UPDATE OR CORRECT SUCH INFORMATION. ANY OUTSTANDING QUOTATIONS MAY BE MODIFIED OR WITHDRAWN AT THE SOLE DISCRETION OF THE COMPANY.
                </p>
                <br>
                <p class="mb-3">
                  COMPLETION OF THIS FORM DOES NOT BIND COVERAGE. THE APPLICANT'S ACCEPTANCE OF THE COMPANY'S QUOTATION IS REQUIRED BEFORE THE APPLICANT MAY BE BOUND AND A POLICY ISSUED. THE APPLICANT AGREES THAT THIS APPLICATION, IF THE INSURANCE COVERAGE APPLIED FOR IS WRITTEN, SHALL BE THE BASIS OF THE CONTRACT WITH THE INSURANCE COMPANY, AND BE DEEMED TO BE A PART OF THE POLICY TO B BE ISSUED AS IF PHYSICALLY ATTACHED THERETO. THE APPLICANT HEREBY AUTHORIZES THE RELEASE OF CLAIMS INFORMATION FROM ANY PRIOR INSURERS TO THE COMPANY.*****
                </p>
              </div>
            </article>
          </div>
        </div>
      </form>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'sip-application-2'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToOne()"></button>
              <button class="pagination-dots" @click="prev()"></button>
              <span class="pagination-dots pagination-current"></span>
              <button
                class="pagination-dots"
                :disabled="!state.pageThreeIsValid || !state.pageFourIsValid"
                @click="navigateToNext('sip-application-4')">
              </button>
            </article>
            <button type="submit" :disabled="!state.pageThreeIsValid"
                    :class="{submitDisabled: !state.pageThreeIsValid}" class="next-btn mont spaced pull-right" @click="navigateToNext('sip-application-4')">Next</button>
          </section>
        </div>
      </div>
    </div>
    <div v-if="!!loading"
         class="position-fixed d-flex justify-content-center align-items-center w-100 h-100 bg-dark"
         style="opacity: 0.7; top: 0; left: 0;">
      <span class="text-white" style="font-size: 16px">Submitting the application...</span>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Datepicker from 'vuejs-datepicker';
import moment from "moment";
import {APP_STATUS} from "@/utils/constants";

export default {
  name: "sip-application-3",
  computed: {
    sipApplication() {
      return this.$store.state.sipApplication.sipApplication;
    },
    state() {
      return this.$store.state.sipApplication;
    },
    errorMsg() {
      return this.$store.state.sipApplication.errorMsg;
    }
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },
  methods: {
    desiredCoverage(event) {
      if(!this.sipApplication.limitOfCoverages.find(coverage => coverage === event.target.value)) {
        if (this.sipApplication.limitOfCoverages.length < 2) {
          this.sipApplication.limitOfCoverages.push(event.target.value);
        } else {
          this.$notify({
            group: 'error',
            type: 'warning',
            title: 'Warning',
            text: 'You can select up to 2 coverages.'
          });
        }
      } else {
        this.sipApplication.limitOfCoverages = this.sipApplication.limitOfCoverages.filter(coverage => coverage !== event.target.value);
      }
    },

    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    formSubmit() {
      this.loading = true;
      this.state.sipApplication.customer.appStatus = APP_STATUS.Completed;
      this.$store.dispatch('sipApplication/createSipApplication');
    },

    prev() {
      this.$router.push({
        name: "sip-application-2"
      });
    },

    navigateToOne() {
      this.$router.push({
        name: "sip-application-1"
      });
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageThreeIsValid = true;
          return;
        }
        this.state.pageThreeIsValid = false;
      });
    },
    formattedCurrentDate() {
      return moment(this.sipApplication.appraiserEsignatureDatetime).format('YYYY-MM-DD');
    },
    validateBeforeSubmitCheck(e){
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.state.sipApplication.realEstateAgentBroker === true){
            this.state.pageThreeIsValid = true;
          }
          else {
            this.state.pageThreeIsValid = false;
            this.validateBeforeSubmit();
          }
          return;
        }
        this.state.pageThreeIsValid = true;

      });
    },
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
  },
  components: {
    Datepicker
  }
};
</script>

<style scoped>
</style>

